import { render, staticRenderFns } from "./WorkerPositionsList.vue?vue&type=template&id=27ca16c2"
import script from "./WorkerPositionsList.vue?vue&type=script&lang=js"
export * from "./WorkerPositionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports